import { render, staticRenderFns } from "./UnsubscribeWeekly.vue?vue&type=template&id=36becdd4&scoped=true&"
import script from "./UnsubscribeWeekly.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeWeekly.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeWeekly.vue?vue&type=style&index=0&id=36becdd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36becdd4",
  null
  
)

export default component.exports